import { MinzeElement } from 'minze'
import type { EventListeners } from 'minze'

export class TjEventGallery extends MinzeElement {
  total = 0
  imageList: any
  touchPosInitX = 0
  onLoaded() {
    this.imageList = this?.children[0]?.children
    if (!this.imageList) {
      this.rerender()
    } else {
      this.total = this.imageList.length
      for (let i = 0; i < this.imageList.length; i++) {
        this.imageList[i].setAttribute('data-gallery-image', '')
        this.imageList[i].setAttribute('data-gallery-image-index', i.toString())
        this.imageList[i].setAttribute('style', 'cursor: pointer;')
        this.addEventListener('click', this.handleImageClick)
      }
    }
  }

  handleImageClick(e: MouseEvent) {
    const target = e.target
    if (target !== null && target instanceof HTMLImageElement) {
      if (target?.hasAttribute('data-gallery-image')) {
        const overlay = this.select('.gallery-overlay')
        const image = overlay?.querySelector('.gallery-image') as HTMLImageElement
        image.setAttribute('data-gallery-image-index', target.getAttribute('data-gallery-image-index') as string)
        image.src = target.src
        overlay?.classList.add('active')
        const counter = overlay?.querySelector('.gallery-image-counter') as HTMLElement
        counter.innerText = `${parseInt(image.getAttribute('data-gallery-image-index') as string) + 1}/${this.total}`
      }
    } else {
      return
    }
  }

  handleKeyUp(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      this.select('.gallery-overlay')?.classList.remove('active')
    }
  }

  handlePrevClick() {
    const image = this.select('.gallery-image') as HTMLImageElement
    let index = parseInt(image.getAttribute('data-gallery-image-index') as string)
    index = index === 0 ? this.total - 1 : index - 1
    image.setAttribute('data-gallery-image-index', index.toString())

    image.style.opacity = '0'
    image.style.transform = 'translateX(100%)'
    setTimeout(() => {
      image.style.transform = 'translateX(-100%)'
      image.src = (this.imageList[index] as HTMLImageElement).src
      setTimeout(() => {
        image.style.opacity = '1'
        image.style.transform = 'translateX(0)'
        const counter = this.select('.gallery-image-counter') as HTMLElement
        counter.innerText = `${index + 1}/${this.total}`
      }, 100)
    }, 100)
  }

  handleNextClick() {
    const image = this.select('.gallery-image') as HTMLImageElement
    let index = parseInt(image.getAttribute('data-gallery-image-index') as string)
    index = index === this.total - 1 ? 0 : index + 1
    image.setAttribute('data-gallery-image-index', index.toString())

    image.style.opacity = '0'
    image.style.transform = 'translateX(-100%)'
    setTimeout(() => {
      image.style.transform = 'translateX(100%)'
      image.src = (this.imageList[index] as HTMLImageElement).src
      setTimeout(() => {
        image.style.opacity = '1'
        image.style.transform = 'translateX(0)'
        const counter = this.select('.gallery-image-counter') as HTMLElement
        counter.innerText = `${index + 1}/${this.total}`
      }, 150)
    }, 100)
  }

  handleTouchStart(e: Event) {
    e.preventDefault()
    if (!(e instanceof TouchEvent)) return
    this.touchPosInitX = e.changedTouches[0].clientX
  }

  handleTouchEnd(e: Event) {
    e.preventDefault()
    if (!(e instanceof TouchEvent)) return
    if (!e?.target) return
    const el = e.target as HTMLElement
    el.style.transform = `translateX(0px)`
    const threshold = 50
    const touchPosEndX = e.changedTouches[0].clientX
    const diff = this.touchPosInitX - touchPosEndX
    if (diff > threshold) {
      this.handleNextClick()
    } else if (diff < -threshold) {
      this.handlePrevClick()
    }
  }

  handleTouchMove(e: Event) {
    e.preventDefault()
    if (!(e instanceof TouchEvent)) return
    if (!e?.target) return
    const maxDiff = 100
    const el = e.target as HTMLElement
    const pos = e.changedTouches[0].clientX
    const diff = pos - this.touchPosInitX
    if (diff < maxDiff && diff > -maxDiff) {
      el.style.transform = `translateX(${diff}px)`
    }
  }
  html = () => `
    <slot name='gallery-layout'></slot>
    <div class='gallery-overlay'>
      <button class='close-gallery cursor-pointer prevent-select'>&times;</button>
      <button class='prev-button cursor-pointer prevent-select'><img src='https://uploads-ssl.webflow.com/650c37547a2a0362b47249be/650c37547a2a0362b4724b98_tj-article-link-arrow.svg'/></button>
      <button class='next-button cursor-pointer prevent-select'><img src='https://uploads-ssl.webflow.com/650c37547a2a0362b47249be/650c37547a2a0362b4724b98_tj-article-link-arrow.svg'/></button>
      <div class='gallery-image-counter'>test</div>
      <div class='gallery-image-wrapper'>
        <img class='gallery-image' src='' alt=''/>
      </div>
    </div>
  `
  css = () => `
    .gallery-image-wrapper{
      position: relative;
      padding: 4rem;
      display: flex;
      align-items: center;
    }
    .gallery-image-counter {
      position: absolute;
      bottom: 1rem;
      text-align: center;
      width: 100%;
      padding: 0.5rem;
      color: white;
      z-index: 1;
    }
    .prev-button, .next-button {
      z-index: 2;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      font-size: 2rem;
      color: white;
      background: none;
      border: none;
      transition: transform 0.1s;
    }
    .prev-button {
      left: 1rem;
    }
    .next-button {
      right: 1rem;
    }
    .prev-button:hover{
      transform: scale(1.2);
    }
    .next-button:hover{
      transform: scale(1.2);
    }
    .prev-button img {
      transform: rotate(180deg);
    }
    .cursor-pointer {
      cursor: pointer;
    }
    .prevent-select {
      -webkit-user-select: none; /* Safari */
      -ms-user-select: none; /* IE 10 and IE 11 */
      user-select: none; /* Standard syntax */
    }
    .gallery-overlay {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.9);
      z-index: 1000;
      transition: all 0.3s;
    }
    .gallery-overlay.active {
      display: flex;
      justify-content: center;
    }
    .gallery-image {
      max-width: 100%;
      max-height: 100%;
      /* width: 100%;
      height: 100%; */
      margin: auto;
      object-fit: cover;
      border-radius: 8px;
      transition: all 0.2s;
    }
    .close-gallery {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 2rem;
      color: white;
      background: none;
      border: none;
      z-index: 3;
    }
    @media only screen and (max-width: 993px) {
      .gallery-image-wrapper {
        padding: 3.5rem 1rem;
      }
      .prev-button, .next-button {
        bottom: 1rem;
        top: auto;
      }
      .prev-button:hover, .next-button:hover {
        transform: scale(1);
      }
      .prev-button {
        left: auto;
        right: 5rem;
      }
      .next-button {
        right: 1rem; 
      }
    }

  `
  eventListeners: EventListeners = [
    [window, 'keyup', (e: any) => this.handleKeyUp(e)],
    ['.close-gallery', 'click', () => this.select('.gallery-overlay')?.classList.remove('active')],
    ['.prev-button', 'click', () => this.handlePrevClick()],
    ['.next-button', 'click', () => this.handleNextClick()],
    ['.gallery-image', 'touchstart', (e) => this.handleTouchStart(e)],
    ['.gallery-image', 'touchend', (e) => this.handleTouchEnd(e)],
    ['.gallery-image', 'touchmove', (e) => this.handleTouchMove(e)],
    [window, 'DOMContentLoaded', () => this.onLoaded()]
  ]
}
